import React, { useState, useCallback } from "react";
import styles from "./MultiSelectDropdown.module.css";

/**
 * @param {{
 *   label: string;
 *   onRemove: () => void;
 *   disabled?: boolean;
 *   icon?: React.ReactNode;
 *   focused?: boolean;
 * }} props
 */
const Chip = ({ label, onRemove, disabled = false, icon, focused = false }) => {
  const [exiting, setExiting] = useState(false);

  const handleRemove = useCallback(
    (e) => {
      e.stopPropagation();
      if (disabled) return;
      setExiting(true);
      window.setTimeout(() => {
        onRemove();
      }, 150);
    },
    [disabled, onRemove]
  );

  return (
    <span
      className={[
        styles.chip,
        exiting ? styles.chipExiting : "",
        disabled ? styles.chipDisabled : "",
        focused ? styles.chipFocused : "",
      ]
        .filter(Boolean)
        .join(" ")}
      onClick={(e) => e.stopPropagation()}
    >
      {icon ? <span className={styles.chipLeading}>{icon}</span> : null}
      <span className={styles.chipLabel} title={label}>
        {label}
      </span>
      {!disabled && (
        <button
          type="button"
          className={styles.chipRemove}
          onClick={handleRemove}
          aria-label={`Remove ${label}`}
        >
          ×
        </button>
      )}
    </span>
  );
};

export default Chip;
